import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-dark py-24 px-4" data-id="element-94">
      <div className="max-w-4xl mx-auto" data-id="element-95">
        <div className="bg-white border border-border-light shadow-xl rounded-3xl p-10 sm:p-16 text-center relative overflow-hidden" data-id="element-96">
          <div className="w-20 h-20 mx-auto bg-blue-50 border border-blue-100 rounded-full flex items-center justify-center mb-8" data-id="element-97">
            <ShieldCheck className="w-10 h-10 text-primary" data-id="element-98" />
          </div>

          <h2 className="text-3xl sm:text-4xl font-black text-text-main mb-6 tracking-tight" data-id="element-99">
            RECUPERA IL TUO TEMPO O TI RIMBORSIAMO
          </h2>

          <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-100">
            Prova Educazione Civica Pronta per{' '}
            <span className="text-primary font-bold" data-id="element-101">7 giorni</span>. Se non ti
            aiuta a risparmiare tempo e organizzare meglio le tue lezioni, ti
            rimborsiamo ogni centesimo.{' '}
            <span className="text-text-main font-bold" data-id="element-102">Senza domande.</span>
          </p>
        </div>
      </div>
    </section>;
}